import { authorizeGetRequest, authorizePostRequest } from "api";
import { IPaginatedResponse } from "models";
import { IPromoCode, IPromoCodeInput } from "models/promoCode";

export const promoCodesApi = (page: number, perPage: number) => {
  return authorizeGetRequest<IPaginatedResponse<IPromoCode>>(
    `promo-codes?page=${page}&per_page=${perPage}`
  );
};

export const createPromoCodeApi = (data: IPromoCodeInput) => {
  return authorizePostRequest<IPromoCode>("promo-codes", data);
};
